import script from "./DeactivationConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeactivationConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./DeactivationConfirmModal.vue?vue&type=style&index=0&id=c859423a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c859423a"]])

export default __exports__